import React from 'react';

const SearchWithStartIcon = (
  props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={18}
      height={18}
      viewBox='0 0 18 18'
      fill='none'
      {...props}
    >
      <path
        d='M13.5 7.5C13.5 4.1925 10.8075 1.5 7.5 1.5C4.1925 1.5 1.5 4.1925 1.5 7.5C1.5 10.8075 4.1925 13.5 7.5 13.5C8.8875 13.5 10.155 13.0275 11.175 12.2325L15 16.0575L16.0575 15L12.2325 11.175C13.02 10.155 13.5 8.8875 13.5 7.5ZM3 7.5C3 5.0175 5.0175 3 7.5 3C9.9825 3 12 5.0175 12 7.5C12 9.9825 9.9825 12 7.5 12C5.0175 12 3 9.9825 3 7.5Z'
        fill='#9F9EA6'
      />
      <path
        d='M12.4326 1.96772C12.4834 1.5114 13.0274 1.2805 13.3909 1.56097L13.4654 1.62906L14.5231 2.75129L16.0648 2.67932C16.6212 2.65315 16.9097 3.33287 16.5044 3.71489L15.3813 4.77299L15.4541 6.31431C15.4803 6.87069 14.8006 7.15919 14.4186 6.75387L13.3596 5.63113L11.8191 5.70361C11.2628 5.72979 10.9743 5.05007 11.3796 4.66804L12.5014 3.60943L12.4298 2.06863L12.4326 1.96772Z'
        fill='#9F9EA6'
        stroke='#121212'
      />
    </svg>
  );
};

export default SearchWithStartIcon;
